import { gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const swingIn: gsapTimelineFunc = (target) => {
  return gsap.timeline().fromTo(
    target,
    {
      duration: 0,
      opacity: 0,
      scaleY: 0,
      transformOrigin: 'center center',
    },
    {
      duration: 1,
      opacity: 1,
      scaleY: 1,
      transformOrigin: 'center center',
    }
  );
};
